<template>
<ItpUsercontrol
  :loading="loading"
  :reloading="reloading"
  :loaded="loaded"
  :error="error"
  @reload="evh_7315092382398562_reload($event, {})"
>
  <ItpFormGroup
    labelColsMd="3"
    contentColsMd="9"
    name="description"
    :label="'Description'|pgettext('ExchangeRateDateRule')"
    :labelAlign="labelAlign"
  >
    <ItpFormInput
      name="description"
      v-model="item.description"
    >
    </ItpFormInput>
  </ItpFormGroup>
  <ItpFormGroup
    labelColsMd="3"
    contentColsMd="9"
    name="reference_month"
    :label="'Reference month'|pgettext('ExchangeRateDateRule')"
    :labelAlign="labelAlign"
    required
  >
    <ItpFormSelect
      name="reference_month"
      v-model="item.reference_month"
      :options="referenceMonthOptions"
      valueField="value"
      textField="name"
      required
    >
    </ItpFormSelect>
  </ItpFormGroup>
  <ItpFormGroup
    :labelColsMd="labelColsMd"
    :contentColsMd="contentColsMd"
    name="day_specifier"
    :label="'Day specifier'|pgettext('ExchangeRateDateRule')"
    :labelAlign="labelAlign"
    required
  >
    <ItpFormSelect
      name="day_specifier"
      v-model="item.day_specifier"
      :options="daySpecifierOptions"
      valueField="value"
      textField="name"
      required
    >
    </ItpFormSelect>
  </ItpFormGroup>
  <ItpFormGroup
    :labelColsMd="labelColsMd"
    :contentColsMd="contentColsMd"
    name="day_value"
    :label="'Day value'|pgettext('ExchangeRateDateRule')"
    :labelAlign="labelAlign"
    contentClass="input-group"
  >
    <ItpFormInput
      type="number"
      name="day_value"
      v-model="item.day_value"
      ref="offsetDays"
    >
    </ItpFormInput>
    <DIV
      class="input-group-append"
    >
      <span
        class="input-group-text"
      >
        {{ 'day'|pgettext('InputGroupAddon') }}
      </span>
    </DIV>
  </ItpFormGroup>
</ItpUsercontrol>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class ExchangeRateDateRule extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "usercontrol",
  };

  beforeCreate() {
  }

  @Prop({
    required: true,
    type: Object,
  })
  item!: object;

  @Watch('item')
  onItem(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("item")
  }

  @Prop({
    type: Boolean,
  })
  editing!: boolean;

  @Watch('editing')
  onEditing(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("editing")
  }

  @Prop({
    default: 3,
  })
  labelColsMd!: any;

  @Watch('labelColsMd')
  onLabel_cols_md(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("labelColsMd")
  }

  @Prop({
    default: 9,
  })
  contentColsMd!: any;

  @Watch('contentColsMd')
  onContent_cols_md(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("contentColsMd")
  }

  labelAlign!: any;
  metadata!: any;

  async $$load_metadata() {
    return this.$app.repo.get('ui_metadata')
  }

  ux!: any;
  dataMembers = ['labelAlign', 'metadata', 'ux'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        labelAlign: "right",
        metadata: null,
        ux: null,
      },
    }
  }

  get referenceMonthOptions() {
    if (this.loaded) {

      return this.metadata.exchange_rate_date_reference_month_options
    }
    return null;
  }

  get daySpecifierOptions() {
    if (this.loaded) {

      return this.metadata.exchange_rate_date_day_specifier_options
    }
    return null;
  }

  get target() {
    if (this.loaded) {

      return this.item
    }
    return null;
  }

  async evh_7315092382398562_reload(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_reload.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_reloadComponentData_2398: actions.ReloadComponentDataAction;
    evh_7315092382398562_reload_2397: actions.EventHandlerImpl;
    evh_7315092382398562_reload: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_reloadComponentData_2398 = new actions.ReloadComponentDataAction(
      {
        events: [],
      }
    );
    const evh_7315092382398562_reload_2397 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_reloadComponentData_2398,
        event: "reload",
        displayName: "reloadComponentData",
      }
    );
    const evh_7315092382398562_reload = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_reload_2397],
      }
    );
    return {
      act_7315092382398562_reloadComponentData_2398,
      evh_7315092382398562_reload_2397,
      evh_7315092382398562_reload,
    }
  }
}

Vue.component("ExchangeRateDateRule", ExchangeRateDateRule);

</script>